import { BsImage, BsAlarm } from 'react-icons/bs'

import { ReactComponent as DeliveryPlan } from '../../../assets/icons/delivery_plan.svg'
import { ReactComponent as ReportIcon } from '../../../assets/icons/report.svg'
import { ReactComponent as MediaIcon } from '../../../assets/icons/media.svg'
import { ReactComponent as SpecificationsIcon } from '../../../assets/icons/specifications.svg'
import { ReactComponent as CreativeAssetsIcon } from '../../../assets/icons/creative-assets-icon.svg'
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo-icon.svg'
import { ReactComponent as OtherIcon } from '../../../assets/icons/other-icon.svg'

import { CHIP_COLORS } from '../../../constants/other'
import { RIGHT_STATUS } from '../../../constants/rights'

export const PLAN_FILE_TYPE = 'plan'
export const REPORT_FILE_TYPE = 'report'
export const PROOF_FILE_TYPE = 'proof'
export const SPECIFICATIONS_FILE_TYPE = 'specifications'
export const CREATIVE_ASSETS_FILE_TYPE = 'creative_assets'
export const LOGO_FILE_TYPE = 'logo'
export const OTHER_FILE_TYPE = 'other'

export const fileTypes = {
  [PLAN_FILE_TYPE]: {
    icon: DeliveryPlan,
    label: 'Delivery plan'
  },
  [REPORT_FILE_TYPE]: {
    icon: ReportIcon,
    label: 'Report'
  },
  [PROOF_FILE_TYPE]: {
    icon: MediaIcon,
    label: 'Proof of delivery'
  },
  [SPECIFICATIONS_FILE_TYPE]: {
    icon: SpecificationsIcon,
    label: 'Specifications'
  },
  [CREATIVE_ASSETS_FILE_TYPE]: {
    icon: CreativeAssetsIcon,
    label: 'Creative Assets'
  },
  [LOGO_FILE_TYPE]: {
    icon: LogoIcon,
    label: 'Logo'
  },
  [OTHER_FILE_TYPE]: {
    icon: OtherIcon,
    label: 'Other'
  }
}

export const rightsHolderFileTypesList = [
  {
    value: SPECIFICATIONS_FILE_TYPE,
    label: 'Specifications'
  },
  {
    value: PLAN_FILE_TYPE,
    label: 'Delivery plan'
  },
  {
    value: REPORT_FILE_TYPE,
    label: 'Report'
  },
  {
    value: PROOF_FILE_TYPE,
    label: 'Proof of delivery'
  }
]

export const partnerFileTypesList = [
  {
    value: CREATIVE_ASSETS_FILE_TYPE,
    label: 'Creative Assets'
  },
  {
    value: LOGO_FILE_TYPE,
    label: 'Logo'
  }
]

export const sharedFileTypesList = [
  {
    value: OTHER_FILE_TYPE,
    label: 'Other'
  }
]

const partnershipIcons = {
  BsAlarm,
  BsImage
}

export const getIcon = iconName => {
  return partnershipIcons[iconName] || BsImage
}

export const rightStatusColors = {
  [RIGHT_STATUS.LIVE]: CHIP_COLORS.success,
  [RIGHT_STATUS.UPCOMING]: CHIP_COLORS.warning,
  [RIGHT_STATUS.DELAYED]: CHIP_COLORS.error,
  [RIGHT_STATUS.WITH_ISSUES]: CHIP_COLORS.error,
  [RIGHT_STATUS.DRAFT]: CHIP_COLORS.neutral,
  [RIGHT_STATUS.COMPLETED]: CHIP_COLORS.neutral
}
